import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** OPERATIONS API CONFIG                                         ***!
  \*******************************************************************************/

export const apiConfig = {
  // CHECKER INBOX AND TASKS
  MakerCheckers: BOM.baseUrl("makercheckers"),
  MakerCheckersTreasury: BOM.baseUrl("makercheckers", "treasury"),
  Search: BOM.baseUrl("search"),
  Loans: BOM.baseUrl("loans"),
  Batches: BOM.baseUrl("batches"),
  Rescheduleloans: BOM.baseUrl("rescheduleloans"),
  Clients: BOM.baseUrl("clients"),
  Offices: BOM.baseUrl("offices"),
  Audits: BOM.baseUrl("audits"),
  Bond: BOM.baseUrl("loanproducts"),
};

//
/*!*******************************************************************************!
  !*** OPERATIONS LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
  id: "ID",
  resourceId: " Resource ID",
  status: "Status",
  madeBy: "Made By",
  action: "Action",
  entity: "Entity ",
  branch: "Branch",
  madeDate: "Made Date",
  checker: "Checker",
  checkedDate: " Checked Date",
  customer: "Customer",
  fromDate: "From Date",
  checkedTo: "Checked To",
  checkedFrom: "Checked From",
  toDate: "To Date",
  searchByUser: "Search By User (maker)",
  checkedStartPeriod: "Checked Start Period",
  checkedEndPeriod: "Checked End Period",
  maker: "Maker",
  changePassword: "Change Password",
  repeatPassword: "Repeat Password",
  password: "Password",
  userName: "Login Name",
  email: "Email",
  staff: "Staff",
  accountOfficer: "Account Officer",
  value: "Value",
  edit: "Edit",
  makerCheckerTasks: "Maker Checker Tasks",
  id: "ID",
  madeOnDate: "Made on Date",
  time: "Time",
  user: "User",
  entity: "Entity",
  manageCheckerInbox: "Manage Checker Inbox",
  manageCheckerInboxList: "Manage Checker Inbox List",
  detailCheckerInbox: "Detail Checker Inbox",
  date: "Date",
  approveCheckerMsg: "Checker Approved Successfully",
  rejectCheckerMsg: "Checker Rejected Successfully",
  deleteCheckerMsg: "Checker Deleted Successfully",
  // CHECKER INBOX AND TASKS
  manageLoanApproval: "Manage Loan Approval",
  detailLoanApproval: "Loan Approval Detail",
  loanPurpose: "Loan Purpose",
  loan: "Loan",
  amount: "Amount",
  manageLoanDisbursal: "Manage Loan Disbursal",
  detailLoanDisbursal: "Loan Disbursal Detail",
  loanAccountNumber: "Loan account number",
  loanProduct: "Loan Product",
  principal: "Principal",
  manageRescheduleLoan: "Manage Reschedule",
  rescheduleRequest: "Reschedule Request#",
  rescheduleFrom: "	Reschedule From",
  rescheduleReason: "Reschedule Reason",
  searchCheckerInbox: "Search Checker Inbox",
  manageClientApproval: "Manage Client Approval",
  clientApproval: "Client Approval",
  clientNumber: "Client Number",
  activationDate: "Activation Date",
  office: "Branch",
  dealReference: "Deal Reference",
  counterParty: "Counter Party",
  proposeRate: "Propose Rate",
  dealTenor: "Deal Tenor",
  dealAmount: "Deal Amount",
  moneyMarketBond: "MM - Bond",
  createMoneyMarketBond: "Create MM - Bond",
  manageMoneyMarketInterbankPlacement: "MM Interbank Placement",
  createMoneyMarketInterbankPlacement: "Create new deal...",
  detailMoneyMarketInterbankPlacement: "Manage deal placement...",
  manageContractBookingInterbankplacement: "Interbank Placement",
  contractBookingInterbankplacement: "Product Listing",
  createContractBookingInterbankplacement: "Create Contract",
};

/*!*******************************************************************************!
    !*** OPERATIONS STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  yesOrNoData: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  filterByEntries: [
    { label: "All", value: "All" },
    { label: "Manual Entries", value: "Manual Entries" },
    { label: "System Entries", value: "System Entries" },
  ],
  yesOrNo: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],

  trueOrFalseData: [
    { label: "True", value: true },
    { label: "False", value: false },
  ],

  manageCheckerInboxBreadcrumbItems: [
    { title: labelConfig.manageCheckerInbox },
  ],

  detailCheckerInboxBreadcrumbItems: [
    { title: <Link to="/sms0800">{labelConfig.manageCheckerInbox}</Link> },
    { title: labelConfig.detailCheckerInbox },
  ],

  manageLoanApprovalBreadcrumbItems: [
    { title: labelConfig.manageLoanApproval },
  ],
  manageLoanDisbursalBreadcrumbItems: [
    { title: labelConfig.manageLoanDisbursal },
  ],
  manageRescheduleLoanBreadcrumbItems: [
    { title: labelConfig.manageRescheduleLoan },
  ],

  searchCheckerInboxBreadcrumbItems: [
    { title: <Link to="/sms0800">{labelConfig.manageCheckerInbox}</Link> },
    { title: labelConfig.searchCheckerInbox },
  ],

  manageClientApprovalBreadcrumbItems: [
    { title: labelConfig.manageClientApproval },
  ],

  moneyMarketBondBreadcrumbItems: [{ title: labelConfig.moneyMarketBond }],
  moneyMarketInterbankPlacementBreadcrumbItems: [
    { title: labelConfig.manageMoneyMarketInterbankPlacement },
  ],

  contractbookingInterbankPlacementBreadcrumbItems: [
    { title: labelConfig.contractBookingInterbankplacement },
  ],
};
